<template>
  <banner-description
    title="aboutus.ourTeam"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconDeepBlue', imgFormat: 'svg' }"
    :imgObj="{ componentName: 'aboutus', imgName: 'ourTeam', imgFormat: 'svg' }"
    description="aboutus.ourTeamDesc"
    descColor="#4E4E4E"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useAboutUsStore } from "@/stores/aboutus";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const aboutusStore = useAboutUsStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>